import * as Sentry from '@sentry/vue';

import learnApi from '@/api/learnApi';

export const updateLearnProgression = async ({ params, vueThis }) => {
  try {
    const currentPath = vueThis.$route.fullPath;


    // 조건 : 파라미터 존재
    const isParamValid = params && params.learnId && params.progressionId;

    if (!isParamValid) {
      // 센트리 로깅 추가
      Sentry.withScope((scope) => {
        scope.setTag('error_type', 'learn_progression_blocked');
        scope.setTag('component', 'learnProgressionUtil');
        scope.setExtra('current_path', currentPath);
        scope.setExtra('params', params);
        scope.setExtra('is_param_valid', isParamValid);
        scope.setExtra('route_params', vueThis.$route.params);
        scope.setExtra('route_query', vueThis.$route.query);
        
        const message = `[LEARN PROGRESSION BLOCKED] URL: ${currentPath} | Params: ${JSON.stringify(params)} | isParamValid: ${isParamValid}`;
        Sentry.captureMessage(message, 'warning');
      });
      
      return false;
    }

    // 조건 통과하면 실제 API 호출
    return learnApi.learnLessonProgression(params);
  } catch (err) {
    return Promise.reject(err);
  }
};